import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.Contract.StatusFlow.IResponse;
type Headers = Api.Core.Contract.StatusFlow.IHeaders;
const url = '/api/Sales/Contract/StatusFlow';
export default async function contractStatusFlowApi(): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
